import DestinationInput from './DestinationInput';

export default DestinationInput